var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xl-2 col-lg-2 col-md-3"},[_c('div',{staticClass:"footer-links"},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.linkList),function(link){return _c('li',{key:link.to},[_c('NuxtLink',{attrs:{"to":link.to}},[_c('span',[_vm._v(_vm._s(link.name))])])],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }